import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import HtmlContent from "../components/HtmlContent"
import Layout from "../components/Layout"

export const GenericPageTemplate = ({ title, overview, content }) => {
  return (
    <section className="wrapper">
      <div className="inner">
        <header className="major">
          <h2>{title}</h2>
          <p>{overview}</p>
        </header>
        <HtmlContent className="content" content={content} />
      </div>
    </section>
  )
}

GenericPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  overview: PropTypes.string,
  content: PropTypes.string,
}

const GenericPage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <Layout isHome={false}>
      <GenericPageTemplate
        title={post.frontmatter.title}
        overview={post.frontmatter.overview}
        content={post.html}
      />
    </Layout>
  )
}

export default GenericPage

GenericPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export const pageQuery = graphql`
  query ServicesPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        overview
      }
    }
  }
`
